import React, {PureComponent} from 'react'
import { translate } from 'react-i18next';
import {getUrlImage, gtmSend} from '../../../helpers';
// import {Icon} from '../../Common/Icon';

import cx from '../../../styles';

class TrackerCardBanner extends PureComponent {
    constructor(props) {
        super(props);

        this.designType = 1; 
        if([2, 4, 6, 8, 10].indexOf(this.props.appReducer.randomUserNumber) > -1) {
            this.designType = 2;
        }    

        this.designTypeTxt = 'turquoise';
        if(this.designType === 2) {
            this.designTypeTxt = 'blue';
        }

        this.bannerType = "pregnancy"; //baby | pregnancy
        
        this.downloadUrl = this.props.configReducer.siteUrl + "app/download?utm_source=feeds-tracker-cards-community&utm_medium=web-"+this.props.appReducer.country+"&utm_campaign=app-download";
    }

    componentDidMount() {
        //gtmSend('dynamic', 'Feeds tracker cards', 'show', ('designType-' + this.designTypeTxt));
    }

    onHandleClick = () => {
        gtmSend('dynamic', 'Feeds tracker cards', 'click', ('designType-' + this.designTypeTxt));
    }

    render() {
        // let t = this.props.t;

        if(this.props.designType) {
            this.designType = this.props.designType; 
        }

        if(this.props.bannerType) {
            this.bannerType = this.props.bannerType;
        }

        const newKey = this.bannerType + '-' + this.props.appReducer.country
        
        let img = "";
        switch(newKey) {
            case 'pregnancy-th':
                if(this.designType === 1) {
                    img = getUrlImage({imgPath: 'tap-assets/article-bottom-app-download-widget/App-Download-Article-Bottom-Widget-baby-th-blue.gif'})
                }
                else {
                    img = getUrlImage({imgPath: 'tap-assets/article-bottom-app-download-widget/App-Download-Article-Bottom-Widget-baby-th-turquoise.gif'})    
                }
            break;
            
            case 'baby-th':
                if(this.designType === 1) {
                    img = getUrlImage({imgPath: 'tap-assets/article-bottom-app-download-widget/App-Download-Article-Bottom-Widget-pregnant-th-blue.gif'})
                }
                else {
                    img = getUrlImage({imgPath: 'tap-assets/article-bottom-app-download-widget/App-Download-Article-Bottom-Widget-pregnant-th-turquoise.gif'})    
                }
            break;

            case 'pregnancy-id':
                if(this.designType === 1) {
                    img = getUrlImage({imgPath: 'tap-assets/article-bottom-app-download-widget/App-Download-Article-Bottom-Widget-baby-id-blue.gif'})
                }
                else {
                    img = getUrlImage({imgPath: 'tap-assets/article-bottom-app-download-widget/App-Download-Article-Bottom-Widget-baby-id-turquoise.gif'})    
                }
            break;
            
            case 'baby-id':
                if(this.designType === 1) {
                    img = getUrlImage({imgPath: 'tap-assets/article-bottom-app-download-widget/App-Download-Article-Bottom-Widget-pregnant-id-blue.gif'})
                }
                else {
                    img = getUrlImage({imgPath: 'tap-assets/article-bottom-app-download-widget/App-Download-Article-Bottom-Widget-pregnant-id-turquoise.gif'})    
                }
            break;

            case 'pregnancy-my':
                if(this.designType === 1) {
                    img = getUrlImage({imgPath: 'tap-assets/article-bottom-app-download-widget/App-Download-Article-Bottom-Widget-baby-my-blue.gif'})
                }
                else {
                    img = getUrlImage({imgPath: 'tap-assets/article-bottom-app-download-widget/App-Download-Article-Bottom-Widget-baby-my-turquoise.gif'})    
                }
            break;
            
            case 'baby-my':
                if(this.designType === 1) {
                    img = getUrlImage({imgPath: 'tap-assets/article-bottom-app-download-widget/App-Download-Article-Bottom-Widget-pregnant-my-blue.gif'})
                }
                else {
                    img = getUrlImage({imgPath: 'tap-assets/article-bottom-app-download-widget/App-Download-Article-Bottom-Widget-pregnant-my-turquoise.gif'})    
                }
            break;

            case 'pregnancy-ph':
                if(this.designType === 1) {
                    img = getUrlImage({imgPath: 'tap-assets/article-bottom-app-download-widget/App-Download-Article-Bottom-Widget-baby-ph-blue.gif'})
                }
                else {
                    img = getUrlImage({imgPath: 'tap-assets/article-bottom-app-download-widget/App-Download-Article-Bottom-Widget-baby-ph-turquoise.gif'})    
                }
            break;
            
            case 'baby-ph':
                if(this.designType === 1) {
                    img = getUrlImage({imgPath: 'tap-assets/article-bottom-app-download-widget/App-Download-Article-Bottom-Widget-pregnant-ph-blue.gif'})
                }
                else {
                    img = getUrlImage({imgPath: 'tap-assets/article-bottom-app-download-widget/App-Download-Article-Bottom-Widget-pregnant-ph-turquoise.gif'})    
                }
            break;

            case 'pregnancy-vn':
                if(this.designType === 1) {
                    img = getUrlImage({imgPath: 'tap-assets/article-bottom-app-download-widget/App-Download-Article-Bottom-Widget-baby-vn-blue.gif'})
                }
                else {
                    img = getUrlImage({imgPath: 'tap-assets/article-bottom-app-download-widget/App-Download-Article-Bottom-Widget-baby-vn-turquoise.gif'})    
                }
            break;
            
            case 'baby-vn':
                if(this.designType === 1) {
                    img = getUrlImage({imgPath: 'tap-assets/article-bottom-app-download-widget/App-Download-Article-Bottom-Widget-pregnant-vn-blue.gif'})
                }
                else {
                    img = getUrlImage({imgPath: 'tap-assets/article-bottom-app-download-widget/App-Download-Article-Bottom-Widget-pregnant-vn-turquoise.gif'})    
                }
            break;

            case 'pregnancy-sg':
                if(this.designType === 1) {
                    img = getUrlImage({imgPath: 'tap-assets/article-bottom-app-download-widget/App-Download-Article-Bottom-Widget-baby-sg-blue.gif'})
                }
                else {
                    img = getUrlImage({imgPath: 'tap-assets/article-bottom-app-download-widget/App-Download-Article-Bottom-Widget-baby-sg-turquoise.gif'})    
                }
            break;
            
            case 'baby-sg':
                if(this.designType === 1) {
                    img = getUrlImage({imgPath: 'tap-assets/article-bottom-app-download-widget/App-Download-Article-Bottom-Widget-pregnant-sg-blue.gif'})
                }
                else {
                    img = getUrlImage({imgPath: 'tap-assets/article-bottom-app-download-widget/App-Download-Article-Bottom-Widget-pregnant-sg-turquoise.gif'})    
                }
            break;

            default:
                if(this.bannerType === 'pregnancy') {
                    if(this.designType === 1) {
                        img = getUrlImage({imgPath: 'tap-assets/article-bottom-app-download-widget/App-Download-Article-Bottom-Widget-baby-sg-blue.gif'})
                    }
                    else {
                        img = getUrlImage({imgPath: 'tap-assets/article-bottom-app-download-widget/App-Download-Article-Bottom-Widget-baby-sg-turquoise.gif'})    
                    }
                }
                else {
                    if(this.designType === 1) {
                        img = getUrlImage({imgPath: 'tap-assets/article-bottom-app-download-widget/App-Download-Article-Bottom-Widget-pregnant-sg-blue.gif'})
                    }
                    else {
                        img = getUrlImage({imgPath: 'tap-assets/article-bottom-app-download-widget/App-Download-Article-Bottom-Widget-pregnant-sg-turquoise.gif'})    
                    }
                }
        }
        
        return (
            <div className={cx("tacker-card-banner", this.designTypeTxt, this.bannerType)}>
                <a onClick={() => this.onHandleClick()} href={this.downloadUrl} title="get app">
                    <img src={img} alt="get app banner" loading="lazy" />
                </a>
            </div>
        )
    }
}

export default translate()(TrackerCardBanner)